import { ToothRestorationType, ToothType } from '../../../../graphql/graphql';

export interface RestorationOption {
	label: string;
	value: ToothRestorationType;
}

type ButtonOption = Record<ToothRestorationType, RestorationOption>;
type RestorationButtonOption = Record<ToothType, RestorationOption[]>;

export const BUTTON_OPTIONS: ButtonOption = {
	[ToothRestorationType.Filling]: {
		label: 'patientTreatment.meddiDENT.dentalCross.restorationModal.filling',
		value: ToothRestorationType.Filling,
	},
	[ToothRestorationType.Veneer]: {
		label: 'patientTreatment.meddiDENT.dentalCross.restorationModal.veneer',
		value: ToothRestorationType.Veneer,
	},
	[ToothRestorationType.Crown]: {
		label: 'patientTreatment.meddiDENT.dentalCross.restorationModal.crown',
		value: ToothRestorationType.Crown,
	},
	[ToothRestorationType.Inlay]: {
		label: 'patientTreatment.meddiDENT.dentalCross.restorationModal.inlay',
		value: ToothRestorationType.Inlay,
	},
	[ToothRestorationType.Onlay]: {
		label: 'patientTreatment.meddiDENT.dentalCross.restorationModal.onlay',
		value: ToothRestorationType.Onlay,
	},
	[ToothRestorationType.PartialCrown]: {
		label:
			'patientTreatment.meddiDENT.dentalCross.restorationModal.partialCrown',
		value: ToothRestorationType.PartialCrown,
	},
};

const INCISOR_RESTORATION_BUTTON_OPTIONS = [
	BUTTON_OPTIONS[ToothRestorationType.Filling],
	BUTTON_OPTIONS[ToothRestorationType.Veneer],
	BUTTON_OPTIONS[ToothRestorationType.Crown],
];

const CANINE_RESTORATION_BUTTON_OPTIONS = [
	BUTTON_OPTIONS[ToothRestorationType.Filling],
	BUTTON_OPTIONS[ToothRestorationType.Veneer],
	BUTTON_OPTIONS[ToothRestorationType.Crown],
];

const PREMOLAR_RESTORATION_BUTTON_OPTIONS = [
	BUTTON_OPTIONS[ToothRestorationType.Filling],
	BUTTON_OPTIONS[ToothRestorationType.Inlay],
	BUTTON_OPTIONS[ToothRestorationType.Onlay],
	BUTTON_OPTIONS[ToothRestorationType.Veneer],
	BUTTON_OPTIONS[ToothRestorationType.PartialCrown],
	BUTTON_OPTIONS[ToothRestorationType.Crown],
];

const MOLAR_RESTORATION_BUTTON_OPTIONS = [
	BUTTON_OPTIONS[ToothRestorationType.Filling],
	BUTTON_OPTIONS[ToothRestorationType.Inlay],
	BUTTON_OPTIONS[ToothRestorationType.Onlay],
	BUTTON_OPTIONS[ToothRestorationType.PartialCrown],
	BUTTON_OPTIONS[ToothRestorationType.Crown],
];

export const RESTORATION_BUTTON_OPTIONS: RestorationButtonOption = {
	[ToothType.Incisor]: INCISOR_RESTORATION_BUTTON_OPTIONS,
	[ToothType.Canine]: CANINE_RESTORATION_BUTTON_OPTIONS,
	[ToothType.Premolar]: PREMOLAR_RESTORATION_BUTTON_OPTIONS,
	[ToothType.Molar]: MOLAR_RESTORATION_BUTTON_OPTIONS,
};
